import env from '@/env';
import createAuthorizedApiClient from '../authorized-api-client';

export const serviceDirectoryApiClient = createAuthorizedApiClient(env.api.baseUrl.serviceDirectory, true);
